import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { UpdateNotDeliveredReasonComponent } from './update-not-delivered-reason/update-not-delivered-reason.component'
import { CreateNotDeliveredReasonComponent } from './create-not-delivered-reason/create-not-delivered-reason.component'
import { NotDeliveredReasonComponent } from './not-delivered-reason.component'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const notDeliveredReasonRoutes: Routes = [
  {
    path: 'admin/not-delivered-reason',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'MOBILE_NOT_DELIVERED_REASON',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        component: NotDeliveredReasonComponent,
        data: {
          permissions: {
            only: 'MOBILE_NOT_DELIVERED_REASON',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'create',
        component: CreateNotDeliveredReasonComponent,
        data: {
          permissions: {
            only: 'MOBILE_NOT_DELIVERED_REASON',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/update',
        component: UpdateNotDeliveredReasonComponent,
        data: {
          permissions: {
            only: 'MOBILE_NOT_DELIVERED_REASON',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
